import { BaseModel } from '../classes/query-builder.class';

export class Site extends BaseModel {
  public table: string = 'sites';
  public schema: Object = {
    id: 'INTEGER PRIMARY KEY AUTOINCREMENT',
    hashed_id: 'VARCHAR',
    client_id: 'VARCHAR',
    name: 'VARCHAR'
  };
}
